<template>
  <div class="skeleton"></div>
</template>

<script>
export default {};
</script>

<style scoped>
.skeleton {
  width: 100%;
  height: var(--filter-height);
  border-radius: 6px;

  --filter-height: 48px;
  --filter-top-padding: 0px;
  --filter-row-height: 48px;
  --filter-skeleton: linear-gradient(
    var(--secondary-blue-lighter) var(--filter-height),
    transparent 0
  );

  --field-height: 48px;
  --territory-width: 448px;
  --territory-height: var(--filter-row-height);
  --territory-position: 0px var(--filter-top-padding);
  --territory-skeleton: linear-gradient(
    var(--basic-white) var(--field-height),
    transparent 0
  );

  --date-mode-width: 413px;
  --date-mode-height: var(--filter-row-height);
  --date-mode-position: 462px var(--filter-top-padding);
  --date-mode-skeleton: linear-gradient(
    var(--basic-white) var(--field-height),
    transparent 0
  );

  --date-range-width: 232px;
  --date-range-height: var(--filter-row-height);
  --date-range-position: 888px var(--filter-top-padding);
  --date-range-skeleton: linear-gradient(
    var(--basic-white) var(--field-height),
    transparent 0
  );

  --blur-width: 200px;
  --blur-size: var(--blur-width) var(--filter-height);
  --blur: linear-gradient(
    90deg,
    rgba(226, 226, 226, 0) 0,
    rgba(226, 226, 226, 0.6) 50%,
    rgba(226, 226, 226, 0) 100%
  );

  --blur-from-position: 0 0;
  --blur-to-position: 350% 0;

  background-repeat: no-repeat;
  background-image: var(--blur), var(--territory-skeleton),
    var(--date-mode-skeleton), var(--date-range-skeleton),
    var(--filter-skeleton);

  background-size: var(--blur-size),
    var(--territory-width) var(--territory-height),
    var(--date-mode-width) var(--date-mode-height),
    var(--date-range-width) var(--date-range-height), 100% 100%;

  background-position: var(--blur-from-position), var(--territory-position),
    var(--date-mode-position), var(--date-range-position), 0 0;

  animation: loading 1.5s infinite;
}
@keyframes loading {
  to {
    background-position: var(--blur-to-position), var(--territory-position),
      var(--date-mode-position), var(--date-range-position), 0 0;
  }
}
</style>
